































import { getMfaQR } from '@/api/Auth';
import { copyToClipBoard } from '@/helpers/copyToClipBoard';

export default {
  name: 'MfaQR',
  props: {
    token: {
      type: String,
      required: true
    }
  },
  data(): {
    mfaQrCode: null | string;
    mfaValue: null | string;
    isLoading: boolean;
  } {
    return {
      mfaQrCode: null,
      mfaValue: null,
      isLoading: false
    };
  },
  created(): void {
    this.getData();
  },
  methods: {
    getData(): void {
      this.isLoading = true;

      getMfaQR(this.token)
        .then((data) => {
          this.mfaValue = data.value;
          this.mfaQrCode = data.qrCode;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    copyToClipBoard
  }
};
